// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i7IRl","colMin":"styles_colMin__2CqW6"};